module.exports = __webpack_public_path__ + "static/img/设计师5.75db89e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/设计师5.jpg
// module id = SODe
// module chunks = 1